import React, { useCallback, useEffect, useMemo } from 'react';
import {
  Actions,
  Action,
  HistoryIcon,
  PostAddIcon,
  RateReviewOutlinedIcon,
  Typography,
} from '@gogame/components';

import { Screen } from '@gogame/screens';

import {
  useChatContext,
  ExistingChat,
  NewChat,
  useFocusInput,
} from 'components/AIChatbot';

import { useFeedback } from 'scenes/AIChatbot/data';

import { useCreateMessage, useLoadMessages } from '../data';
import Message from './Message';
import HistorySidePage from './HistorySidePage';

export const ScreenChatContent = () => {
  const focusInput = useFocusInput();
  const { chatId, setChatId, openChildComponent } = useChatContext();

  const [createMessage, { isLoading }] = useCreateMessage();

  const { isRefetching, data: messages, isFetched } = useLoadMessages(chatId);

  const handleSubmitMessage = useCallback(
    async ({ query }) => {
      await createMessage({ query });
    },
    [createMessage]
  );

  const [feedbackChat] = useFeedback();

  const handleFeedback = useCallback(async () => {
    await feedbackChat({
      chatId,
    });
  }, [feedbackChat, chatId]);

  const handleOpenHistory = useCallback(async () => {
    await openChildComponent(HistorySidePage, {
      currentChatId: chatId,
      onSelectChat: async (newChatId) => {
        setChatId(newChatId);
        await new Promise((resolve) => setTimeout(resolve, 500));
        focusInput();
      },
    });
  }, [openChildComponent, chatId, setChatId, focusInput]);

  const handleOpenNewChat = useCallback(async () => {
    setChatId(null);
    focusInput();
  }, [setChatId, focusInput]);

  return (
    <React.Fragment>
      <Screen.Toolbar.Actions>
        <Actions>
          {chatId && (
            <Action
              icon={<PostAddIcon />}
              tooltip={'Create new chat'}
              tooltipPlacement={'bottom'}
              onClick={handleOpenNewChat}
            />
          )}
          {chatId && (
            <Action
              icon={<RateReviewOutlinedIcon />}
              tooltip={'Submit feedback'}
              tooltipPlacement={'bottom'}
              onClick={handleFeedback}
            />
          )}
          <Action
            icon={<HistoryIcon />}
            tooltip={'History'}
            tooltipPlacement={'bottom'}
            onClick={handleOpenHistory}
          />
        </Actions>
      </Screen.Toolbar.Actions>

      {chatId ? (
        <ExistingChat
          isLoading={isLoading}
          isRefetching={isRefetching}
          isFetched={isFetched}
          messages={messages || []}
          onSubmitMessage={handleSubmitMessage}
          slots={{
            message: Message,
          }}
        />
      ) : (
        <NewChat isLoading={isLoading} onSubmitMessage={handleSubmitMessage}>
          <Typography variant={'h6'} color={'text.primary'} align={'center'}>
            Hi, welcome to GoGame help desk expert.
          </Typography>
          <Typography variant={'body1'} align={'center'}>
            I'm here to answer any of your GoGame capability questions.
          </Typography>
          <Typography variant={'body1'} align={'center'}>
            What can I assist you with today?
          </Typography>
        </NewChat>
      )}
    </React.Fragment>
  );
};
